import { useCallback } from 'react';
import { useAppNavigate } from '@/utils/navGuard';

export function useSuggestDialog() {
  const navigate = useAppNavigate();

  const openSuggestDialog = useCallback(() => {
    navigate('/submit-shop');
  }, [navigate]);

  const openSuggestRoasterDialog = useCallback(() => {
    navigate('/submit-roaster');
  }, [navigate]);

  return {
    openSuggestDialog,
    openSuggestRoasterDialog,
  };
}

export default useSuggestDialog;
